import { z } from 'zod';

import {
    schemaAcceptedOffersConsors,
    schemaAcceptedOffersEuropace,
    schemaAcceptedOffersEuropaceSync,
    schemaAcceptedOffersManual,
} from './discriminatedUnions';

export const AcceptedOffersTableDefinitionZod = z.discriminatedUnion('source', [
    schemaAcceptedOffersEuropace,
    schemaAcceptedOffersEuropaceSync,
    schemaAcceptedOffersConsors,
    schemaAcceptedOffersManual,
]);

export type AcceptedOffersTableSchema = z.infer<typeof AcceptedOffersTableDefinitionZod>;
export type AcceptedOffersTableSchemaEuropace = z.infer<typeof schemaAcceptedOffersEuropace>;
export type AcceptedOffersTableSchemaEuropaceSync = z.infer<typeof schemaAcceptedOffersEuropaceSync>;
export type AcceptedOffersTableSchemaConsors = z.infer<typeof schemaAcceptedOffersConsors>;
export type AcceptedOffersTableSchemaManual = z.infer<typeof schemaAcceptedOffersManual>;
